var map = {
	"./cleaned/1.cleaned_floor.svg": "934c",
	"./cleaned/2.cleaned_toilet.svg": "9e73",
	"./cleaned/3.cleaned_shower.svg": "b60f",
	"./cleaned/4.cleaned_sink.svg": "b23a",
	"./cleaned/5.cleaned_mirro.svg": "9688",
	"./cleaned/6.cleaned_stainless_steel.svg": "b3fb",
	"./counter/45.people_counter.svg": "5862",
	"./counter/50.counter.svg": "f740",
	"./counter/51.counter_men.svg": "86ff",
	"./counter/52.counter_woman.svg": "878c",
	"./counter/53.counter_handycap.svg": "d47a",
	"./fixed/192.fixed_soap_dispenser.svg": "f4c7",
	"./fixed/193.fixed_paper_dispenser.svg": "208f",
	"./fixed/194.fixed_coffee_machine.svg": "815a",
	"./fixed/195.fixed_water_bar.svg": "bfdc",
	"./fixed/27.fixed_shower.svg": "4fac",
	"./fixed/28.fixed_sink.svg": "d166",
	"./fixed/29.fixed_mirro.svg": "e25c",
	"./fixed/30.fixed_stainless_steel.svg": "d320",
	"./fixed/31.fixed_blockage.svg": "13305",
	"./fixed/32.fixed_door.svg": "aa6a",
	"./fixed/33.fixed_fluid_taps.svg": "759a",
	"./fixed/34.fixed_lightning.svg": "41fd",
	"./fixed/35.fixed_broken_toilet.svg": "c933",
	"./food/170.dining_room.svg": "ef3e",
	"./food/171.food_variety.svg": "c045",
	"./food/172.quality_of_the_food.svg": "0912",
	"./food/173.amount_of_the_food.svg": "82e8",
	"./food/174.quality_of_cooking.svg": "af51",
	"./food/175.side_courses.svg": "f5db",
	"./food/176.meat.svg": "2bea",
	"./food/177.desserts.svg": "39f8",
	"./food/178.vegetarian.svg": "7f2c",
	"./food/179.salad_bar.svg": "af64",
	"./food/180.main_courses.svg": "e64f",
	"./food/181.service.svg": "3341",
	"./food/182.dining_room_cleanlines.svg": "8137",
	"./food/183.plates_and_cutlery_cleanliness.svg": "29c0",
	"./food/184.product_inventory.svg": "9214",
	"./food/185.furnichers.svg": "3787",
	"./food/186.toilets.svg": "8b13",
	"./kitchen/47.zone_is_dirty.svg": "1964",
	"./kitchen/612.Appliances.svg": "04cb",
	"./kitchen/613.Frodktim.svg": "abc2",
	"./kitchen/614.Broken_chair.svg": "ad57",
	"./kitchen/615.Broken_abinet.svg": "05f9",
	"./kitchen/616.Micro.svg": "1126",
	"./kitchen/617.toaster.svg": "9dec",
	"./kitchen/618.Clogged_sink_malfunction.svg": "f828",
	"./kitchen/619.Coffee_cooling_malfunction.svg": "692e",
	"./kitchen/620.No_coffee_beans.svg": "0755",
	"./kitchen/621.Machine_ailure.svg": "876a",
	"./kitchen/622.That_dirty.svg": "6623",
	"./kitchen/623.Dirty_refrigerator.svg": "a58d",
	"./kitchen/624.Dirty_ables.svg": "1f93",
	"./kitchen/625.Dirty_floor.svg": "6efd",
	"./kitchen/626.Plates.svg": "4ecb",
	"./kitchen/627.Selver_spone.svg": "5157",
	"./kitchen/628.Cold_drinks_cups.svg": "b135",
	"./kitchen/629.Hot_drink_cups.svg": "c363",
	"./kitchen/631.problem_sink.svg": "ed51",
	"./kitchen/632.A_dripping_faucet.svg": "50ef",
	"./kitchen/632.problem_lightning.svg": "b2ee",
	"./kitchen/81.coffee_tea.svg": "824c",
	"./kitchen/82.water_bar.svg": "3d66",
	"./kitchen/83.disposable_dishes.svg": "8de8",
	"./language/100.hebrew.svg": "52a5",
	"./language/100.עברית.svg": "9e8c",
	"./language/101.español.svg": "bfbd",
	"./language/102.français.svg": "b6b9",
	"./language/103.english.svg": "4e93",
	"./language/104.русский.svg": "419c",
	"./language/105.italiano.svg": "85dc",
	"./language/106.አማርኛ.svg": "6d3d",
	"./language/107.português.svg": "5e1c",
	"./linked/400.room_link.svg": "ed1f",
	"./linked/401.floor_link.svg": "c564",
	"./officials/42.supervise.svg": "b780",
	"./officials/43.maintenance.svg": "1602",
	"./officials/44.cleaner.svg": "6286",
	"./officials/45.tag_cleaner.svg": "2970",
	"./officials/46.zone_is_clean.svg": "4f3c",
	"./officials/47.zone_is_dirty.svg": "789a",
	"./officials/48.cleaner_arrived.svg": "a321",
	"./officials/49.start_clean_zone.svg": "8017",
	"./officials/55.maintenance_fixed.svg": "6ac5",
	"./officials/56.maintenance_problem.svg": "b65f",
	"./officials/59.end_clean_zone.svg": "cd94",
	"./problem/18.problem_shower.svg": "84da",
	"./problem/187.problem_coffee_machine.svg": "082d",
	"./problem/188.problem_water_bar.svg": "4eff",
	"./problem/19.problem_sink.svg": "ea06",
	"./problem/196.problem_urinals.svg": "230b",
	"./problem/197.blockage_toilet.svg": "f66f",
	"./problem/198.appliance_problem.svg": "742e",
	"./problem/199.problem_broken_door.svg": "be9e",
	"./problem/20.problem_mirro.svg": "29b4",
	"./problem/200.problem_broken_door_lock.svg": "91e4",
	"./problem/200.problem_door_lock.svg": "7f6a",
	"./problem/201.problem_broken_toilet_seat.svg": "64b4",
	"./problem/202.problem_broken_niagara.svg": "9d3e",
	"./problem/203.broken_hand_paper_dispenser_Hand_dryer.svg": "88892",
	"./problem/21.problem_stainless_steel.svg": "4cc8",
	"./problem/213.problem_bed_smell.svg": "2589",
	"./problem/214.problem_broken_toilet_handle.svg": "1238",
	"./problem/215.problem_handle_door.svg": "b42b",
	"./problem/217.wall_painting.svg": "c7ae",
	"./problem/22.problem_blockage.svg": "1bae",
	"./problem/220.problem_right_elevator.svg": "871c",
	"./problem/221.problem_left_elevator.svg": "969a",
	"./problem/223.problem_sink_blockage.svg": "85fe",
	"./problem/224.electric_problem.svg": "f783",
	"./problem/226.problem_air_condition.svg": "1328",
	"./problem/23.problem_door.svg": "ea49",
	"./problem/24.problem_fluid_taps.svg": "f88c",
	"./problem/25.problem_lightning.svg": "fa76",
	"./problem/26.problem_broken_toilet.svg": "a456",
	"./problem/56.maintenance_problem.svg": "7ff8",
	"./problem/57.problem_soap_dispenser.svg": "7109",
	"./problem/58.problem_paper_dispenser.svg": "c512",
	"./problem/88.maintenance.svg": "b0c1",
	"./reports/10.dirty_shower.svg": "761b",
	"./reports/108.partial_Information.svg": "7da8",
	"./reports/11.dirty_sink.svg": "fedb",
	"./reports/12.dirty_mirror.svg": "850c",
	"./reports/13.dirty_stainless_steel.svg": "3d0b",
	"./reports/14.missing_paper_towel.svg": "f31d",
	"./reports/15.missing_soap.svg": "2cf7",
	"./reports/16.missing_toilet_paper.svg": "8e63",
	"./reports/190.dirty_stairs.svg": "8fa6",
	"./reports/191.missing_toiletries.svg": "b897",
	"./reports/191.toiletries.svg": "2f90",
	"./reports/196.problem_urinals.svg": "1ab3",
	"./reports/197.blockage_toilet.svg": "6e38",
	"./reports/199.hand_dryer.svg": "bda6",
	"./reports/204.rug.svg": "1f79",
	"./reports/205.tables.svg": "7094",
	"./reports/206.kitchen.svg": "07b7",
	"./reports/207.air_condition.svg": "a95e",
	"./reports/208.dirty_urinals.svg": "58b8",
	"./reports/208.problem_urinals.svg": "872b",
	"./reports/209.blockage_toilet.svg": "54f0",
	"./reports/210.hand_dryer.svg": "22f6",
	"./reports/212.non-sticky_carpet.svg": "effe",
	"./reports/216.call_cleaner.svg": "e6ef",
	"./reports/218.missing_paper.svg": "86fa",
	"./reports/219.clean_surface.svg": "2edf",
	"./reports/222.missing_hend_sanitizer.svg": "7e06",
	"./reports/225.missing_coffe_tea.svg": "cddd",
	"./reports/227.dishwashing.svg": "f317",
	"./reports/228.kitchen_cleanliness.svg": "8af5",
	"./reports/229.weekly_cleaning.svg": "a085",
	"./reports/230.general_arrangement.svg": "935b",
	"./reports/231.meeting_room.svg": "eaf0",
	"./reports/232.refrigerator.svg": "94f0",
	"./reports/233.kitchen_supplies.svg": "07d1",
	"./reports/234.toilet_service.svg": "fe0d",
	"./reports/234.toilet_services.svg": "d060",
	"./reports/235.carousel_door.svg": "8123",
	"./reports/236.desk.svg": "be69",
	"./reports/237.compressor.svg": "0f41",
	"./reports/238.compressor_rails.svg": "6696",
	"./reports/239.compressor_drainage.svg": "6301",
	"./reports/240.dust.svg": "b3943",
	"./reports/243.food.svg": "fa19",
	"./reports/244.room_conditions.svg": "86fad",
	"./reports/245.Kindness_sensitivity.svg": "415d",
	"./reports/246.Explain_process.svg": "8b83",
	"./reports/247.Personal_attention.svg": "9098",
	"./reports/37.like.svg": "9366",
	"./reports/39.like.svg": "9587",
	"./reports/402.services.svg": "b063",
	"./reports/509.operating_instructions.svg": "f1a5",
	"./reports/510.general.svg": "21b7",
	"./reports/511.connection_problem.svg": "4253",
	"./reports/512.lighting.svg": "870f",
	"./reports/54.full_garbage_can.svg": "3f7b",
	"./reports/60.status_toilet_paper.svg": "afa8",
	"./reports/65.status_head_paper.svg": "9c4a",
	"./reports/7.bad_smell.svg": "08dc",
	"./reports/70.status_soap.svg": "84b2",
	"./reports/75.status_garbage_can.svg": "2e9c",
	"./reports/8.dirty_floor.svg": "7fa0",
	"./reports/80.cleaning.svg": "c720",
	"./reports/80.general_cleaning.svg": "6759",
	"./reports/84.non-sticky_carpet.svg": "8b73",
	"./reports/85.head_coverage.svg": "8dbc",
	"./reports/86.something_else.svg": "201a",
	"./reports/87.missing_clothing.svg": "ebed",
	"./reports/9.dirty_lavatory_seat.svg": "1ef7",
	"./smileys/130.need_improved.svg": "fbde",
	"./smileys/131.liked.svg": "9c14",
	"./smileys/132.pleasant.svg": "66f5",
	"./smileys/36.very_good.svg": "6fe3",
	"./smileys/37.excellent.svg": "f3b8",
	"./smileys/38.good.svg": "36fa",
	"./smileys/39.like.svg": "ffdc",
	"./smileys/40.needs_improvement.svg": "f459",
	"./smileys/41.not_good.svg": "2fc6",
	"./survey/109.professionalism.svg": "2e7f",
	"./survey/110.the_attitude_of_the_epresentative.svg": "7a58",
	"./survey/111.waiting_time_for_service.svg": "fa40",
	"./survey/112.other_aspect_of_service.svg": "68b7",
	"./survey/113.language_of_the_service.svg": "f6c1",
	"./survey/114.rocedure_for_making_an_appointment.svg": "ce80",
	"./survey/115.physical_conditions.svg": "0e4f",
	"./survey/120.found_another.svg": "8892",
	"./survey/121.found_similar.svg": "f7c4",
	"./survey/122.did_not_find.svg": "a5ea",
	"./survey/123.found.svg": "1b0c",
	"./survey/140.eilat_resident.svg": "c54d",
	"./survey/141.once_a_week.svg": "d46c",
	"./survey/142.once_a_month.svg": "9b26",
	"./survey/143.twice_a_year.svg": "6ba0",
	"./survey/144.once_a_year.svg": "14c1",
	"./survey/145.something_else.svg": "5771",
	"./survey/150.friend.svg": "7d66",
	"./survey/151.newspaper.svg": "d753",
	"./survey/152.google.svg": "e729",
	"./survey/153.zap.svg": "5074",
	"./survey/160.vacuum_cleaner.svg": "a411",
	"./survey/161.gaming_consoles.svg": "01e1",
	"./survey/162.laptop.svg": "6aef",
	"./survey/163.cellular.svg": "a644",
	"./survey/164.shop.svg": "841e",
	"./survey/165.general_cleaning.svg": "1aa2",
	"./survey/166.restaurant_complex_cleaning.svg": "6714",
	"./survey/250.service_problem.svg": "55ab",
	"./survey/251.welcome_you.svg": "67c8",
	"./survey/252.invoice_submitted.svg": "b6e0",
	"./survey/253.thank_you_bought.svg": "8830",
	"./survey/254.problem_seller.svg": "a4e9",
	"./survey/255.lapel_pin.svg": "ed4a",
	"./survey/256.proper_performance.svg": "687c",
	"./survey/257.name_tag.svg": "47ee",
	"./survey/258.operational.svg": "966f",
	"./survey/259.app_revealed.svg": "4a3b",
	"./survey/260.register_load.svg": "416c",
	"./survey/261.visibility_problem.svg": "b103",
	"./survey/262.clean_storefront.svg": "d6d9",
	"./survey/263.clean_garbage.svg": "9d02",
	"./survey/264.clean_tables_chairs.svg": "7480",
	"./survey/265.clean_shop_floor.svg": "a286",
	"./survey/266.product_show.svg": "9efc",
	"./survey/267.refrigerators_show.svg": "016a",
	"./survey/268.coffee_accessories.svg": "491e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa6b";